import React, { useState } from 'react';
import { Box, Flex, useDisclosure } from '@chakra-ui/react';
import { Outlet } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { Header } from './Header';
import { GlobalSearchModal } from './GlobalSearchModal';
import { NotificationsDrawer } from './NotificationsDrawer';
import { MessagesDrawer } from './MessagesDrawer';

export const DashboardLayout = () => {
  const [isCollapsed, setIsCollapsed] = useState(false);
  const searchModal = useDisclosure();
  const notificationsDrawer = useDisclosure();
  const messagesDrawer = useDisclosure();

  return (
    <Flex minH="100vh" bg="#F8FAFC" _dark={{ bg: '#0B0F17' }}>
      {/* Collapsible Sidebar */}
      <Sidebar isCollapsed={isCollapsed} onToggle={() => setIsCollapsed(!isCollapsed)} />

      {/* Main Content Area */}
      <Flex flex="1" direction="column" minW="0" overflowX="hidden">
        <Header
          onOpenSearch={searchModal.onOpen}
          onOpenNotifications={notificationsDrawer.onOpen}
          onOpenMessages={messagesDrawer.onOpen}
        />

        <Box as="main" flex="1" p={{ base: 4, md: 8 }} maxW="1600px" w="100%" mx="auto">
          <Outlet />
        </Box>
      </Flex>

      {/* Global Modals & Drawers */}
      <GlobalSearchModal isOpen={searchModal.isOpen} onClose={searchModal.onClose} />
      <NotificationsDrawer isOpen={notificationsDrawer.isOpen} onClose={notificationsDrawer.onClose} />
      <MessagesDrawer isOpen={messagesDrawer.isOpen} onClose={messagesDrawer.onClose} />
    </Flex>
  );
};
